import { LitElement } from 'lit-element';
import { KatalIcon } from '../icon';
import { KatalComponent } from '../../shared/base';
import styles from './icon-shadow.lit.scss';

/**
 * @component {kat-icon-shadow} KatalIconShadow private internal component
 * @status hidden
 */
export class IconShadow extends KatalIcon {
  static get styles() {
    return styles;
  }

  createRenderRoot() {
    return LitElement.prototype.createRenderRoot.call(this);
  }
}

KatalComponent.register('kat-icon-shadow', IconShadow);
